/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';

import { IDefaLandingPageViewProps } from './defa-landing-page';

export default (props: IDefaLandingPageViewProps) => {
    const {
        LandingPage,
        heading,
        description,
        links,
        backToDEFALink,
        backgroundImageStyle
    } = props;

    return (
        <Module {...LandingPage}>
            {heading}
            {description}
            {links}
            {backToDEFALink}
            {backgroundImageStyle}
        </Module>
    );
};
